import Login from "./Login";
import LoginVerification from "./LoginVerification";
import CustomerBioData from "./CustomerBioData";
import CustomerSelfRegistration from "./CustomerSelfRegistration";

const authPages = {
  Login,
  LoginVerification,
  CustomerBioData,
  CustomerSelfRegistration,
};
export default authPages;
